var e = /* @__PURE__ */ ((t) => (t.BottomStart = "bottom-start", t.BottomCenter = "bottom-center", t.BottomEnd = "bottom-end", t.TopStart = "top-start", t.TopCenter = "top-center", t.TopEnd = "top-end", t))(e || {});
const o = [
  "bottom-center",
  "bottom-end",
  "bottom-start",
  "top-center",
  "top-end",
  "top-start"
], r = {
  "bottom-end": "end-x",
  "bottom-start": "start-x",
  "bottom-center": "end-y",
  "top-end": "end-x",
  "top-start": "start-x",
  "top-center": "start-y"
}, n = {
  role: "alert",
  "aria-relevant": "additions",
  "aria-live": "assertive"
};
export {
  n as TOASTER_ARIA_ATTRIBUTES,
  o as TOASTER_POSITION,
  r as TOAST_POSITION_ANIMATION_MATRIX,
  e as ToasterPosition
};
